import React, { ForwardedRef, forwardRef } from 'react'
import * as S from './styles'
import { IProps } from './types'

const CheckBox = forwardRef(
	(props: IProps, ref: ForwardedRef<HTMLInputElement>) => {
		const { label, id, errorMessage, ...rest } = props

		return (
			<S.Wrapper>
				<S.CheckBoxWrapper>
					<S.CheckBox ref={ref} type={'checkbox'} {...rest} id={id} />
					<S.CheckMark />
				</S.CheckBoxWrapper>
				{label && <S.Label htmlFor={id}>{label}</S.Label>}

				{errorMessage ? <S.ErrorMessage>{errorMessage}</S.ErrorMessage> : null}
			</S.Wrapper>
		)
	}
)

export { CheckBox }
